import { Button } from 'antd';
import { Plus } from 'lucide-react';
import { useState } from 'react';
import { ZoneQuickCreateModal } from '../../../../zones/public/ZoneQuickCreateModal';
import { ZoneSearchSelect } from '../../../../zones/public/ZoneSearchSelect';

interface GarageZoneFieldProps {
  id?: string;
  /** The zone's code, as a garage stores it. */
  value?: string;
  onChange?: (value: string | undefined) => void;
}

/** Where the garage is: any kind of zone, or one made on the spot when the place isn't there yet (gitaumoses4/chukua#421). */
export function GarageZoneField({ id, value, onChange }: GarageZoneFieldProps) {
  const [isAdding, setIsAdding] = useState(false);

  return (
    <>
      <ZoneSearchSelect id={id} value={value} onChange={onChange} className="w-full" />
      <Button type="link" className="px-0" icon={<Plus className="size-4" />} onClick={() => setIsAdding(true)}>
        Add a zone
      </Button>
      <ZoneQuickCreateModal
        open={isAdding}
        onCancel={() => setIsAdding(false)}
        onCreated={(zone) => {
          onChange?.(zone.code);
          setIsAdding(false);
        }}
      />
    </>
  );
}
